// import React from "react";
// import "./notificationPanel.css";

// const NotificationPanel = ({ isOpen, onClose }) => {
//     const tickIcon = `${process.env.PUBLIC_URL}/header/MasterButtonIcon.png`;
//     const bellIcon = `${process.env.PUBLIC_URL}/header/notifications_none.png`;
//     return (
//         <>
//             {/* Overlay to darken the background */}
//             <div className={`overlay ${isOpen ? "show" : ""}`} onClick={onClose}></div>

//             {/* Notification Panel */}
//             <div className={`notification-panel ${isOpen ? "open" : ""}`}>
//                 <div className="notification-header">
//                     <div className="title">
//                         <img src={bellIcon} alt="Bell Icon" className="bell-icon" />
//                         <span>Notifications</span>
//                     </div>

//                     <span className="clear-all">
//                         <img src={tickIcon} alt="Clear All" className="tick-icon" />
//                         <span>Clear all</span>
//                     </span>

//                     {isOpen && (
//                         <button className="close-btn" onClick={onClose}>
//                             ✖ {/* Unicode for close button (optional) */}
//                         </button>
//                     )}
//                 </div>

//                 {/* Notification List */}
//                 <div className="notification-list">
//                     {[...Array(4)].map((_, index) => (
//                         <div className="notification-item" key={index}>
//                             <p className="new-heading">New notification</p>
//                             <p className="para">
//                                 Provident unde aut. Quo est mollitia impedit nostrum iure ratione consequuntur ut
//                             </p>
//                             {index === 0 && <span className="new-dot"></span>}
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </>
//     );
// };

// export default NotificationPanel;
import React, { useState } from "react";
import "./notificationPanel.css";

const NotificationPanel = ({ isOpen, onClose }) => {
    const tickIcon = `${process.env.PUBLIC_URL}/header/MasterButtonIcon.png`;
    const bellIcon = `${process.env.PUBLIC_URL}/header/notifications_none.png`;

    // State for managing notifications
    const [notifications, setNotifications] = useState([
        { id: 1, title: "New notification", message: "First notification message" },
        { id: 2, title: "Reminder", message: "First notification message" },
        { id: 3, title: "Alert", message: "System update scheduled for tonight" },
        { id: 4, title: "Offer", message: "First notification message" },
    ]);

    // Function to clear all notifications
    const handleClearAll = () => {
        setNotifications([]);
    };

    // Function to delete a specific notification
    const handleDeleteNotification = (id) => {
        setNotifications(notifications.filter(notification => notification.id !== id));
    };

    return (
        <>
            {/* Overlay to darken the background */}
            <div className={`overlay ${isOpen ? "show" : ""}`} onClick={onClose}></div>

            {/* Notification Panel */}
            <div className={`notification-panel ${isOpen ? "open" : ""}`}>
                <div className="notification-header">
                    <div className="title">
                        <img src={bellIcon} alt="Bell Icon" className="bell-icon" />
                        <span>Notifications</span>
                    </div>

                    <span className="clear-all" onClick={handleClearAll}>
                        <img src={tickIcon} alt="Clear All" className="tick-icon" />
                        <span>Clear all</span>
                    </span>

                    {isOpen && (
                        <button className="close-btn" onClick={onClose}>
                            ✖ {/* Unicode for close button (optional) */}
                        </button>
                    )}
                </div>

                {/* Notification List */}
                <div className="notification-list">
                    {notifications.length === 0 ? (
                        <p className="no-notifications">No new notifications</p>
                    ) : (
                        notifications.map(notification => (
                            <div className="notification-item" key={notification.id}>
                                <p className="new-heading">{notification.title}</p>
                                <p className="para">{notification.message}</p>
                                
                                {/* Delete Button */}
                                <button className="delete-btn" onClick={() => handleDeleteNotification(notification.id)}>
                                    ✖
                                </button>
                            </div>
                        ))
                    )}
                </div>
                 {/* Bottom Close Button */}
                 <button className="bottom-close-btn" onClick={onClose}>
                    Close
                </button>
            </div>
        </>
    );
};

export default NotificationPanel;
